/**
 * OrbDocCoreConceptsClosedCircuitARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsClosedCircuitARDocScreen
 */

import { useOrbDocCoreConceptsClosedCircuitARDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsClosedCircuitARDocScreenLogic';
import type { OrbDocCoreConceptsClosedCircuitARDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsClosedCircuitARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsClosedCircuitARDocView as OrbDocCoreConceptsClosedCircuitARDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsClosedCircuitARDocBodyView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitARDocBodyView';
import { OrbDocCoreConceptsClosedCircuitARDocFooterView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitARDocFooterView';
import { OrbDocCoreConceptsClosedCircuitARDocHeaderView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsClosedCircuitARDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsClosedCircuitARDocScreenConfig>;
}

export function OrbDocCoreConceptsClosedCircuitARDocScreenView({ config: propsConfig }: OrbDocCoreConceptsClosedCircuitARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsClosedCircuitARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsClosedCircuitARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsClosedCircuitAR" trait="OrbDocCoreConceptsClosedCircuitARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsClosedCircuitARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsClosedCircuitARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsClosedCircuitARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsClosedCircuitARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsClosedCircuitARDocScreenView;
